import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ObservabilityTab } from "@/components/settings/ObservabilityTab";
import { AITab } from "@/components/settings/AITab";
import { APILogTab } from "@/components/settings/APILogTab";
import { Activity, Brain, Globe } from "lucide-react";

export default function AdvancedLogsSettings() {
  return (
    <div className="space-y-6" data-cy="advanced-logs-settings-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Logs Avançados</h1>
        <p className="text-muted-foreground">
          Gerencie logs, observabilidade e configurações de IA
        </p>
      </div>

      <Tabs defaultValue="observability" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="observability" data-cy="observability-tab">
            <Activity className="h-4 w-4 mr-2" />
            Observabilidade
          </TabsTrigger>
          <TabsTrigger value="ai" data-cy="ai-tab">
            <Brain className="h-4 w-4 mr-2" />
            IA
          </TabsTrigger>
          <TabsTrigger value="api" data-cy="api-tab">
            <Globe className="h-4 w-4 mr-2" />
            API
          </TabsTrigger>
        </TabsList>

        <TabsContent value="observability" className="space-y-6">
          <ObservabilityTab />
        </TabsContent>

        <TabsContent value="ai" className="space-y-6">
          <AITab />
        </TabsContent>
        <TabsContent value="api" className="space-y-6">
          <APILogTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}

